"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PdfEditorView_1 = require("./PdfEditorView");
var PdfEditorToolbar_1 = require("./PdfEditorToolbar");
var PdfEditorCanvas_1 = require("./PdfEditorCanvas");
var PdfEditor_module_scss_1 = __importDefault(require("./PdfEditor.module.scss"));
exports.PdfEditor = function (_a) {
    var pdfSource = _a.pdfSource, title = _a.title, hideToolbar = _a.hideToolbar;
    if (!pdfSource)
        return react_1.default.createElement("div", null, "No pdfSource defined");
    return (react_1.default.createElement("div", { className: "d-flex flex-column w-100 h-100" },
        !hideToolbar && react_1.default.createElement(PdfEditorToolbar_1.PdfEditorToolbar, { title: title }),
        react_1.default.createElement("div", { className: "d-flex justify-content-center align-items-start h-100 position-relative", style: { overflowY: 'scroll' } },
            react_1.default.createElement("div", { className: "mt-auto mb-auto " + PdfEditor_module_scss_1.default.editorBlock },
                react_1.default.createElement("div", { className: "position-relative m-6" },
                    react_1.default.createElement(PdfEditorView_1.PdfEditorView, { pdfSource: pdfSource, disableClickRotate: hideToolbar }),
                    react_1.default.createElement(PdfEditorCanvas_1.PdfEditorCanvas, null))))));
};
//# sourceMappingURL=PdfEditor.js.map